import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

export const useMutationShipmentOrderLegRun = () => {
  const queryClient = useQueryClient();

  return {
    restoreSplitLegRun: useMutation(
      (id: number) => axios.post(`/api/v5/shipment_order_leg_runs/${id}/restore_split`),
      {
        onSuccess: () => {
          void queryClient.invalidateQueries({ queryKey: ['shipmentOrderLegRuns'] });
        }
      }
    ),
    restoreSplitLegRuns: useMutation(
      (data: { startOn: string, endOn: string }) => axios.post('/api/v5/shipment_order_leg_runs/restore_splits',
                                                     { start_on: data.startOn, end_on: data.endOn }),
      {
        onSuccess: () => {
          void queryClient.invalidateQueries({ queryKey: ['shipmentOrderLegRuns'] });
        }
      }
    ),
  }
};
